import React, { Component } from 'react';
import cx from 'classnames';

import { withWindow } from '../../decorators/window';

import Popup from '../global/popup';
import DatePickerCalendarMonth from './date-picker-calendar-month';

class DatePickerNewGrid extends Component {
  constructor() {
    super();

    this.state = {
      activeDate: false,
      currentMonthIndex: 0,
      hoveredDate: null,
    };

    this.handleDatePicked = this.handleDatePicked.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  render() {
    const {
      breakingPoint,
      calendarHotel,
      calendarModel,
      currentLeg,
      isDatePickerActive,
      isMulticity,
      isPopupInline,
      isQuickBooker,
      itinerary,
      language,
      multiCityItineraries,
      multiCitySelectorIndex,
      noButton,
      popupPosition,
      popupType,
      storefront,
      timatic,
    } = this.props;

    let { breakpointNewDesign } = this.props;
    const { currentMonthIndex, hoveredDate } = this.state;

    breakpointNewDesign = breakingPoint ? breakingPoint : breakpointNewDesign;

    // on large breakpointNewDesign we show 2 months at a time.
    const showingDoubles = breakpointNewDesign === 'large';

    const isFirstMonth = currentMonthIndex === 0;

    // last month is defined by breakpointNewDesign. so -2 for doubles
    // and -1 for single month
    const isLastMonth = showingDoubles ?
      (currentMonthIndex === calendarModel.months.size - 2) : (currentMonthIndex === calendarModel.months.size - 1);

    const buttonLeftArrowClasses = cx({
      'Icon': true,
      'Icon--calendarArrowLeft': true,
      'is-disabled': isFirstMonth,
    });

    const buttonRightArrowClasses = cx({
      'Icon': true,
      'Icon--calendarArrowRight': true,
      'is-disabled': isLastMonth,
    });

    const datePickerClasses = cx({
      'DatePickerWrapper': true,
      'timatic': timatic ? true : false,
      'is-positionRelative': isQuickBooker ? false : isPopupInline,
      'is-hidden': !isDatePickerActive,
    });

    const FormComponent = noButton ? 'div' : 'button';

    return (
      <Popup
        className={ datePickerClasses }
        isPopupActive={ isDatePickerActive }
        popupType={ popupType }
        position={ popupPosition }>
        <FormComponent
          className={ buttonLeftArrowClasses }
          disabled={ isFirstMonth }
          onClick={ () => this.handleButtonArrowClick(currentMonthIndex - 1) }/>
        <div className='DatePicker-calendar'>
          <DatePickerCalendarMonth
            calendarHotel={ calendarHotel }
            currentLeg={ currentLeg }
            handleDatePicked={ this.handleDatePicked }
            hoveredDate={ hoveredDate }
            isMulticity={ isMulticity }
            itinerary={ itinerary }
            language={ language }
            month={ calendarModel.getMonthByIndex(currentMonthIndex) }
            monthIndex={ currentMonthIndex }
            multiCityItineraries={ multiCityItineraries }
            multiCitySelectorIndex={ multiCitySelectorIndex }
            noButton={ noButton }
            onDayMouseOver={ (dateValue) => this.handleDayMouseOver(dateValue) }
            onMouseLeave={ this.handleMouseLeave }
            storefront={ storefront } />
        </div>
        { breakpointNewDesign === 'large' ?
          <div className='DatePicker-calendar'>
            <DatePickerCalendarMonth
              calendarHotel={ calendarHotel }
              currentLeg={ currentLeg }
              handleDatePicked={ this.handleDatePicked }
              hoveredDate={ hoveredDate }
              isMulticity={ isMulticity }
              itinerary={ itinerary }
              language={ language }
              month={ calendarModel.getMonthByIndex(currentMonthIndex + 1) }
              monthIndex={ currentMonthIndex + 1 }
              multiCityItineraries={ multiCityItineraries }
              multiCitySelectorIndex={ multiCitySelectorIndex }
              noButton={ noButton }
              onDayMouseOver={ (dateValue) => this.handleDayMouseOver(dateValue) }
              onMouseLeave={ this.handleMouseLeave }
              storefront={ storefront } />
          </div> : null }
        <FormComponent
          className={ buttonRightArrowClasses }
          disabled={ isLastMonth }
          onClick={ () => this.handleButtonArrowClick(currentMonthIndex + 1) } />
      </Popup>
    );
  }

  handleDatePicked(itinerary) {
    const { handleItinerarySelection } = this.props;

    handleItinerarySelection(itinerary);
  }

  handleButtonArrowClick(monthIndex) {
    this.setState({
      currentMonthIndex: monthIndex,
    });
  }

  handleDayMouseOver(date) {
    this.setState({
      hoveredDate: date,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoveredDate: null,
    });
  }
}

export default withWindow(DatePickerNewGrid);
